import {Component, Input, input, OnDestroy, OnInit} from '@angular/core';
import {ItemService} from "../../../_services/dto-services/item.service";
import {Component_Create} from "../_models/component-create";
import {InterchangeableComponentGroup_Create} from "../_models/interchangeable-component-group-create";
import {ItemDto} from "../../../models/item-dto";
import {Subscription} from "rxjs";
import {NgOptionComponent, NgSelectComponent} from "@ng-select/ng-select";
import {FormsModule} from "@angular/forms";
import {MatTooltip} from "@angular/material/tooltip";
import {UnitAmountFieldComponent} from "../unit-amount-field/unit-amount-field.component";
import {NgSelectScrollAwareDirective} from "../../../_directives/ng-select-scroll-aware.directive";

@Component({
  selector: 'app-interchangeable-group-attached-widget',
  templateUrl: './interchangeable-group-attached-widget.component.html',
  imports: [
    FormsModule,
    NgSelectComponent,
    NgOptionComponent,
    MatTooltip,
    UnitAmountFieldComponent,
    NgSelectScrollAwareDirective
  ],
  styleUrl: './interchangeable-group-attached-widget.component.scss'
})
export class InterchangeableGroupAttachedWidgetComponent implements OnInit, OnDestroy {
  @Input() component!: Component_Create;

  /**
   * CSS selector of the container each option dropdown is portaled into (`[appendTo]`, Bug #236).
   *
   * It is an input, not a constant, for three reasons: `appendTo` **throws** when its selector matches nothing
   * (so a hardcoded host id would crash any future reuse of this widget), the target must be a POSITIONED,
   * non-clipping box that only the host knows, and an in-dialog host must never let the z-1050 panel escape to
   * the page shell — it would paint over the dialog. The default is the composition editor's slide-over body,
   * this widget's only production host today (`items.component.html`).
   */
  readonly panelAppendTo = input('#composition-editor-panel');
  protected items: ItemDto[] = [];
  private itemsChangedSubscription: Subscription | undefined;

  constructor(protected ItemService: ItemService) {
  }

  ngOnInit(): void {
    this.itemsChangedSubscription = this.ItemService.itemsChanged.subscribe({
      next: values => {
        this.items = values;
      }
    })
  }

  ngOnDestroy(): void {
    this.itemsChangedSubscription?.unsubscribe();
  }

  useManualComponents() {
    this.component.interchangeableGroup = new InterchangeableComponentGroup_Create();
  }

  protected alternativeRemove(alternative: Component_Create): void {
    if (!this.component.interchangeableGroup) return;
    if (this.component.interchangeableGroup.components.length === 1 && this.component.isOptional()) return;

    let index = this.component.interchangeableGroup.components.indexOf(alternative);
    if (index > -1) this.component.interchangeableGroup.components.splice(index, 1);
  }

  protected alternativeAdd(): void {
    if (!this.ItemService.items || this.ItemService.items.length === 0) return;
    if (!this.component.interchangeableGroup) return;

    let item = this.ItemService.items[0];
    this.component.interchangeableGroup.components.push(Component_Create.create(item, false));
  }
}
